import axios from 'src/app-axios';
import Constants from 'src/constants';

export const invoice = {
  namespaced: true,
  state: {
    invoice: {},
    outstandingInvoices: [],
    invoiceFilters: {},
    paidInvoices: [],
    paidInvoiceFilters: {},
    draftInvoices: [],
    draftInvoiceFilters: {},
    InvoiceDetails: {},
  },
  getters: {
    getInvoice (state) {
      return state.invoice;
    },
    getOutstandingInvoices (state) {
      return state.outstandingInvoices;
    },
    getInvoiceFilters (state) {
      return state.invoiceFilters;
    },
    getPaidInvoices (state) {
      return state.paidInvoices;
    },
    getPaidInvoiceFilters (state) {
      return state.paidInvoiceFilters;
    },
    getDraftInvoices (state) {
      return state.draftInvoices;
    },
    getDraftInvoiceFilters (state) {
      return state.draftInvoiceFilters;
    },
    getInvoiceDetails (state) {
      return state.InvoiceDetails;
    },
  },
  mutations: {
    setCreateInvoice (state, data) {
      state.invoice = data;
    },
    setOutstandingInvoices (state, data) {
      state.outstandingInvoices = [...state.outstandingInvoices, ...data.data];
    },
    resetOutstandingInvoices (state) {
      state.outstandingInvoices = [];
    },
    storeInvoiceFilters (state, data) {
      state.invoiceFilters = data;
    },
    setPaidInvoices (state, data) {
      state.paidInvoices = [...state.paidInvoices, ...data.data];
    },
    resetPaidInvoices (state) {
      state.paidInvoices = [];
    },
    storePaidInvoiceFilters (state, data) {
      state.paidInvoiceFilters = data;
    },
    setDraftInvoices (state, data) {
      state.draftInvoices = [...state.draftInvoices, ...data.data];
    },
    resetDraftInvoices (state) {
      state.draftInvoices = [];
    },
    storeDraftInvoiceFilters (state, data) {
      state.draftInvoiceFilters = data;
    },
    setInvoiceDetails (state, data) {
      state.InvoiceDetails = data;
    },
  },
  actions: {
    async createInvoice ({ commit, dispatch }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/invoices`;
      try {
        const data = await axios.post(url, payload.params);
        commit('setCreateInvoice', data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in createing Invoice',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async uploadInvoice ({ dispatch }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/invoices/upload`;
      try {
        await axios.post(url, payload.document);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in uploading Invoice',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchOutstandingInvoices ({ commit, dispatch }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/invoices`;
      try {
        const data = await axios.get(url, payload.params);
        commit('setOutstandingInvoices', data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting invoices list',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    clearOutstandingInvoices ({ commit }) {
      commit('resetOutstandingInvoices');
    },
    saveInvoiceFilters ({ commit }, payload) {
      commit('storeInvoiceFilters', payload);
    },
    async fetchPaidInvoices ({ commit, dispatch }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/invoices`;
      try {
        const data = await axios.get(url, payload.params);
        commit('setPaidInvoices', data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting invoices list',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    clearPaidInvoices ({ commit }) {
      commit('resetPaidInvoices');
    },
    savePaidInvoiceFilters ({ commit }, payload) {
      commit('storePaidInvoiceFilters', payload);
    },
    async fetchDraftInvoices ({ commit, dispatch }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/invoices`;
      try {
        const data = await axios.get(url, payload.params);
        commit('setDraftInvoices', data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting invoices list',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    clearDraftInvoices ({ commit }) {
      commit('resetDraftInvoices');
    },
    saveDraftInvoiceFilters ({ commit }, payload) {
      commit('storeDraftInvoiceFilters', payload);
    },
    async fetchInvoiceDetails ({ commit, dispatch }, payload) {
      const url = `api/devices/invoices/${payload.invoiceId}`;
      try {
        const data = await axios.get(url);
        commit('setInvoiceDetails', data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting invoice details',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async downloadInvoice ({ dispatch }, payload) {
      const url = `api/devices/organizations/${payload.externalId}/invoices/${payload.invoiceId}/download`;
      axios({
          url: url,
          method: 'GET',
          responseType: 'blob',
      }).then(response => {
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = payload.fileName;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(url);
      }).catch(exception => {
          dispatch('alert/onAlert', {
              message: 'Something went wrong in downloading document file.',
              type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          throw exception;
      });
    },
  },
};
